/**
 *
 * Copyright 2020-2026 Splunk Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */

import { Span } from '@opentelemetry/api'
import type { CLSMetricWithAttribution } from 'web-vitals/attribution'

import { setNumberAttribute, setStringAttribute } from '../../utils/span-attributes'
import { setRectAttributes } from './span-attributes'
import { WebVitalsAttributionOptions } from './types'

export function setCLSAttributionAttributes(
	span: Span,
	metric: CLSMetricWithAttribution,
	options: WebVitalsAttributionOptions,
): void {
	const { attribution } = metric

	setStringAttribute(span, 'cls.largest_shift_target', options.getTarget(attribution.largestShiftTarget))

	setNumberAttribute(span, 'cls.largest_shift_time', attribution.largestShiftTime)
	setNumberAttribute(span, 'cls.largest_shift_value', attribution.largestShiftValue)
	setStringAttribute(span, 'cls.load_state', attribution.loadState)
	setRectAttributes(span, 'cls.largest_shift_source.previous_rect', attribution.largestShiftSource?.previousRect)
	setRectAttributes(span, 'cls.largest_shift_source.current_rect', attribution.largestShiftSource?.currentRect)
}
